import { z } from 'zod';
export const baseLastBowelMovement = z.object({
    wnl: z.boolean().optional(),
    lastBowelMovement: z.string().optional(),
    stoolConsistency: z.string().optional(),
    stoolColor: z.string().optional(),
    stoolAmount: z.string().optional(),
});
export const baseLastBowelMovementRefined = baseLastBowelMovement.refine((data) => data.wnl || data.lastBowelMovement?.trim() || data.stoolConsistency?.trim() || data.stoolColor?.trim() || data.stoolAmount?.trim(), { message: 'At least one answer is required', path: [] });
